import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { googleLogin, refreshUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    const back = location.pathname + location.search;
    googleLogin(sid)
      .then((u) => toast.success(`Welcome, ${u.name || "drummer"}`))
      .catch(() => { toast.error("Google sign-in failed. Please try again."); refreshUser(); })
      .finally(() => navigate(back, { replace: true }));
  }, [location, navigate, googleLogin, refreshUser]);

  return null;
}
